<template>
  <div class="singer-switch-tab">
    <div class="tabs">
      <div class="tab-item" v-for="(item, index) in tabImgList" :key="index" :class="index < 1 ? 'first' : ''" @click="changeTab(index)">
        <img :src="active === index ? item.tabActiveURL : item.tabInActiveURL" :alt="active === index ? '活跃tab' : '非活跃tab'" />
      </div>
    </div>
  </div>
</template>

<script>
import { pauseVideoPlayer } from '../utils'
export default {
  name: "SingerSwitchTab",
  props: {
    homepageImgList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tabImgList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    active: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  computed: {
    activeTabIndex() {
      return this.$store.state.activeTabIndex;
    },
  },
  methods: {
    changeTab(tabIdx) {
      if (this.activeTabIndex === tabIdx) {
        return;
      }
      this.$emit("change-active", tabIdx);
      this.$store.commit("setShareImg", this.homepageImgList[tabIdx]);
      // 暂停音乐
      this.$store.commit("pauseSongId");
      // 暂停视频
      pauseVideoPlayer()
    },
  },
};
</script>

<style lang="scss" scoped>
.singer-switch-tab {
  width: 100%;
  padding: 0 5px;

  .tabs {
    display: flex;
    align-items: flex-start;
    overflow-x: auto;
    .tab-item {
      margin-left: -20px;

      &.first {
        margin-left: 0;
      }

      img {
        height: 98px;
      }
    }
  }
}
</style>
